'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var axios = require('axios');
var createAuthRefreshInterceptor = require('axios-auth-refresh');
var Cookies = require('js-cookie');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var axios__default = /*#__PURE__*/_interopDefaultLegacy(axios);
var createAuthRefreshInterceptor__default = /*#__PURE__*/_interopDefaultLegacy(createAuthRefreshInterceptor);
var Cookies__default = /*#__PURE__*/_interopDefaultLegacy(Cookies);

class Config {
  /** Client base URL */

  /** Client API key */

  /** Client API token storage key */

  /** Client API refresh token storage key */

  /**
   * @param config - SDK configuration
   */
  static configure(config) {
    Config.baseUrl = config.baseUrl;
    Config.key = config.key;
    Config.apiTokenStorageKey = config.apiTokenStorageKey ? config.apiTokenStorageKey : 'sc_api_token';
    Config.refreshTokenStorageKey = config.refreshTokenStorageKey ? config.refreshTokenStorageKey : 'sc_api_refresh_token';
  }
  /**
   * Validates SDK configuration
   */


  static validate() {
    if (!Config.baseUrl) {
      throw new Error('Base URL not set');
    }

    if (!Config.key) {
      throw new Error('No API key set');
    }
  }

}

/**
 * Creates a HTTP client factory
 *
 * @param baseURL - Base URL that will prefix all calls
 * @param key - API key that will be attached to authorise the request
 * @param keyType - API key type Apikey|Bearer
 * @returns An Axios instance
 */
const clientFactory = (baseURL, key, keyType = 'Apikey') => axios__default["default"].create({
  baseURL,
  headers: {
    Authorization: `${keyType} ${key}`
  },
  timeout: 10000
});
/**
 * Creates a HTTP client factory
 *
 * @param baseURL - Base URL that will prefix all calls
 * @param apiKey - API key that will be attached to authorise the request
 * @returns An Axios instance
 */


const apiKeyHttpClient = (baseURL, apiKey) => clientFactory(baseURL, apiKey, 'Apikey');

class BaseWrapper {
  /** HTTP client */
  constructor(apiClient) {
    if (apiClient) {
      this.http = apiClient;
    } else {
      Config.validate();
      this.http = apiKeyHttpClient(Config.baseUrl, Config.key);
    }
  }
  /**
   * @param filters - Filter objects
   * @returns object
   */


  formatFilter(filters) {
    const filterParams = {};

    if (filters.length > 0) {
      for (let i = 0; i < filters.length; i += 1) {
        filterParams[`filters[${i}][property]`] = filters[i].property;
        filterParams[`filters[${i}][value]`] = filters[i].value;
        filterParams[`filters[${i}][operator]`] = filters[i].operator;
      }
    }

    return filterParams;
  }
  /**
   * @param sort - Sort objects
   * @returns object
   */


  formatSort(sort) {
    const sortParams = {};

    if (sort.length > 0) {
      for (let i = 0; i < sort.length; i += 1) {
        sortParams[`sort[${i}][property]`] = sort[i].property;
        sortParams[`sort[${i}][direction]`] = sort[i].direction;
      }
    }

    return sortParams;
  }

}

class AccountWrapper extends BaseWrapper {
  /**
   *
   * @param email
   * @param password
   * @returns IUser
   */
  async login(email, password) {
    const {
      data
    } = await this.http.post('/users/account/login', {
      email: email,
      password: password
    });
    return data;
  }
  /**
   *
   * @param code
   * @returns IResponse
   */


  async activateAccount(code) {
    const {
      data
    } = await this.http.post('/users/account/activate', {
      code: code
    });
    return data;
  }
  /**
   *
   * @param email
   * @returns IResponse
   */


  async resendActivation(email) {
    const {
      data
    } = await this.http.post('/users/account/resend-activation', {
      email: email
    });
    return data;
  }
  /**
   *
   * @param email
   * @returns IResponse
   */


  async forgottenPassword(email) {
    const {
      data
    } = await this.http.post('/users/account/forgotten-password', {
      email: email
    });
    return data;
  }
  /**
   *
   * @param code
   * @param password
   * @returns IResponse
   */


  async resetPassword(code, password) {
    const {
      data
    } = await this.http.post('/users/account/reset-password', {
      code: code,
      password: password
    });
    return data;
  }

}

class AuthWrapper extends BaseWrapper {
  /**
   * @returns IToken
   */
  async generateToken() {
    const {
      data
    } = await this.http.get(`/auth/token/`);
    return data;
  }
  /**
   * @param apiToken
   * @returns IToken
   */


  async getTokenByToken(apiToken) {
    const {
      data
    } = await this.http.get(`/auth/token/` + apiToken);
    return data;
  }
  /**
   * @param apiToken
   * @returns IToken
   */


  async refreshToken(apiToken) {
    const {
      data
    } = await this.http.get(`/auth/token/?refresh_token=` + apiToken);
    return data;
  }

}

class AnalyticWrapper extends BaseWrapper {
  /**
   *
   * @param analyticData
   * @returns IAnalytic
   */
  async trackAnalytic(analyticData) {
    const {
      data
    } = await this.http.post(`/analytics/`, analyticData);
    return data;
  }
  /**
   * @param productId
   * @param analyticData
   * @returns IAnalytic
   */


  async trackAnalyticByProductId(productId, analyticData) {
    const {
      data
    } = await this.http.post(`/analytics/`, { ...{
        product_id: productId
      },
      ...analyticData
    });
    return data;
  }

}

class StoreWrapper extends BaseWrapper {
  /**
   * Get a store
   *
   * @returns IStore
   */
  async getStore(includes = []) {
    let params = {};

    if (includes.length > 0) {
      params = { ...params,
        ...{
          include: includes.join(',')
        }
      };
    }

    const {
      data
    } = await this.http.get('/stores', {
      params
    });
    return data;
  }

}

var RelationshipIncludes;

(function (RelationshipIncludes) {
  RelationshipIncludes["All"] = "*";
})(RelationshipIncludes || (RelationshipIncludes = {}));

var RelationshipIncludes$1 = RelationshipIncludes;

var FilterOperator;

(function (FilterOperator) {
  FilterOperator["Like"] = "LIKE";
  FilterOperator["Equals"] = "=";
  FilterOperator["NotEquals"] = "!=";
  FilterOperator["GreaterThan"] = ">";
  FilterOperator["Where"] = "where";
  FilterOperator["WhereIn"] = "whereIn";
  FilterOperator["WhereBetween"] = "whereBetween";
  FilterOperator["WhereAnd"] = "whereAnd";
})(FilterOperator || (FilterOperator = {}));

var FilterOperator$1 = FilterOperator;

class PageWrapper extends BaseWrapper {
  /**
   * @returns IPage[]
   */
  async getPages(pagination = {
    page: 1
  }, filters = [], sort = [], includes = []) {
    let params = { ...pagination
    };

    if (filters.length > 0) {
      params = { ...params,
        ...this.formatFilter(filters)
      };
    }

    if (sort.length > 0) {
      params = { ...params,
        ...this.formatSort(sort)
      };
    }

    if (includes.length > 0) {
      params = { ...params,
        ...{
          include: includes.join(',')
        }
      };
    }

    const {
      data
    } = await this.http.get('/pages', {
      params
    });
    return data;
  }
  /**
   * @param id
   * @returns IPage
   */


  async getPageById(id) {
    const {
      data
    } = await this.http.get(`/pages/${id}`);
    return data;
  }
  /**
   * @param slug
   * @returns IPage[]
   */


  async getPageBySlug(slug) {
    const filters = [{
      operator: FilterOperator$1.Equals,
      property: 'slug',
      value: slug
    }];
    const {
      data
    } = await this.http.get('/pages', {
      params: { ...this.formatFilter(filters),
        include: RelationshipIncludes$1.All
      }
    });
    return data;
  }

}

class ProductWrapper extends BaseWrapper {
  /**
   * @returns IProduct[]
   */
  async getProducts(pagination = {
    page: 1
  }, filters = [], sort = [], includes = []) {
    let params = { ...pagination
    };

    if (filters.length > 0) {
      params = { ...params,
        ...this.formatFilter(filters)
      };
    }

    if (sort.length > 0) {
      params = { ...params,
        ...this.formatSort(sort)
      };
    }

    if (includes.length > 0) {
      params = { ...params,
        ...{
          include: includes.join(',')
        }
      };
    }

    const {
      data
    } = await this.http.get('/products', {
      params
    });
    return data;
  }
  /**
   * @param id
   * @returns IProduct
   */


  async getProductById(id) {
    const {
      data
    } = await this.http.get(`/products/${id}`);
    return data;
  }
  /**
   * @param slug
   * @returns IProduct[]
   */


  async getProductBySlug(slug) {
    const filters = [{
      operator: FilterOperator$1.Equals,
      property: 'slug',
      value: slug
    }];
    const {
      data
    } = await this.http.get('/products', {
      params: { ...this.formatFilter(filters),
        include: RelationshipIncludes$1.All
      }
    });
    return data;
  }
  /**
   * @returns IProduct[]
   */


  async getRecommendedProducts(productIds, pagination = {
    page: 1
  }, filters = [], sort = [] // includes: Array<string> = [],
  ) {
    let params = { ...{
        product_id: productIds
      },
      ...pagination
    };

    if (filters.length > 0) {
      params = { ...params,
        ...this.formatFilter(filters)
      };
    }

    if (sort.length > 0) {
      params = { ...params,
        ...this.formatSort(sort)
      };
    } // if (includes.length > 0) {
    //   params = { ...params, ...{ include: includes.join(',') } };
    // }


    const {
      data
    } = await this.http.get('/products/recommendations', {
      params
    });
    return data;
  }
  /**
   * @returns IProduct[]
   */


  async searchProducts(query, pagination = {
    page: 1
  }, filters = [], sort = [], includes = []) {
    let params = { ...{
        query: query
      },
      ...pagination
    };

    if (filters.length > 0) {
      params = { ...params,
        ...this.formatFilter(filters)
      };
    }

    if (sort.length > 0) {
      params = { ...params,
        ...this.formatSort(sort)
      };
    }

    if (includes.length > 0) {
      params = { ...params,
        ...{
          include: includes.join(',')
        }
      };
    }

    const {
      data
    } = await this.http.get('/search/products', {
      params
    });
    return data;
  }

}

class BasketWrapper extends BaseWrapper {
  /**
   * @param basketReference
   * @returns IBasket
   */
  async getBasketById(basketReference) {
    const {
      data
    } = await this.http.get(`/baskets/${basketReference}`);
    return data;
  }
  /**
   * @param basketData
   * @param deliveryTypeId
   * @returns IBasket
   */


  async createBasket(basketData, deliveryTypeId = 0) {
    let payload = {
      products: basketData
    };

    if (deliveryTypeId > 0) {
      payload = { ...payload,
        ...{
          delivery_type_id: deliveryTypeId
        }
      };
    }

    const {
      data
    } = await this.http.post('/baskets', payload);
    return data;
  }
  /**
   * @param basketReference
   * @param basketData
   * @param deliveryTypeId
   * @returns IBasket
   */


  async updateBasket(basketReference, basketData, deliveryTypeId = 0) {
    let payload = {
      products: basketData
    };

    if (deliveryTypeId > 0) {
      payload = { ...payload,
        ...{
          delivery_type_id: deliveryTypeId
        }
      };
    }

    const {
      data
    } = await this.http.put(`/baskets/${basketReference}`, payload);
    return data;
  }
  /**
   * @param basketReference
   * @param productId
   * @param quantity
   * @returns IBasket
   */


  async addProductToBasket(basketReference, productId, quantity = 1) {
    const {
      data
    } = await this.http.put(`/baskets/${basketReference}/products/${productId}`, {
      quantity
    });
    return data;
  }
  /**
   * @param basketReference
   * @param productId
   * @returns IBasket
   */


  async deleteProductFromBasket(basketReference, productId) {
    const {
      data
    } = await this.http.delete(`/baskets/${basketReference}/products/${productId}`);
    return data;
  }

}

class ProductTypeWrapper extends BaseWrapper {
  /**
   * @returns IProductType[]
   */
  async getProductTypes(pagination = {
    page: 1
  }, filters = [], sort = [], includes = []) {
    let params = { ...pagination
    };

    if (filters.length > 0) {
      params = { ...params,
        ...this.formatFilter(filters)
      };
    }

    if (sort.length > 0) {
      params = { ...params,
        ...this.formatSort(sort)
      };
    }

    if (includes.length > 0) {
      params = { ...params,
        ...{
          include: includes.join(',')
        }
      };
    }

    const {
      data
    } = await this.http.get('/product-types', {
      params
    });
    return data;
  }
  /**
   * @param id
   * @returns IProductType
   */


  async getProductTypeById(id) {
    const {
      data
    } = await this.http.get(`/product-types/${id}`);
    return data;
  }
  /**
   * @param slug
   * @returns IProductType[]
   */


  async getProductTypeBySlug(slug) {
    const filters = [{
      operator: FilterOperator$1.Equals,
      property: 'slug',
      value: slug
    }];
    const {
      data
    } = await this.http.get('/product-types', {
      params: { ...this.formatFilter(filters),
        include: RelationshipIncludes$1.All
      }
    });
    return data;
  }

}

class CategoryWrapper extends BaseWrapper {
  /**
   * @returns ICategory[]
   */
  async getCategories(pagination = {
    page: 1
  }, filters = [], sort = [], includes = []) {
    let params = { ...pagination
    };

    if (filters.length > 0) {
      params = { ...params,
        ...this.formatFilter(filters)
      };
    }

    if (sort.length > 0) {
      params = { ...params,
        ...this.formatSort(sort)
      };
    }

    if (includes.length > 0) {
      params = { ...params,
        ...{
          include: includes.join(',')
        }
      };
    }

    const {
      data
    } = await this.http.get('/categories', {
      params
    });
    return data;
  }
  /**
   * @param id
   * @returns ICategory
   */


  async getCategoryById(id) {
    const {
      data
    } = await this.http.get(`/categories/${id}`);
    return data;
  }
  /**
   * @param slug
   * @returns ICategory[]
   */


  async getCategoryBySlug(slug) {
    const filters = [{
      operator: FilterOperator$1.Equals,
      property: 'slug',
      value: slug
    }];
    const {
      data
    } = await this.http.get('/categories', {
      params: { ...this.formatFilter(filters),
        include: RelationshipIncludes$1.All
      }
    });
    return data;
  }

}

class CategoryOptionWrapper extends BaseWrapper {
  /**
   * @returns ICategoryOption[]
   */
  async getCategoryOptions(pagination = {
    page: 1
  }, filters = [], sort = [], includes = []) {
    let params = { ...pagination
    };

    if (filters.length > 0) {
      params = { ...params,
        ...this.formatFilter(filters)
      };
    }

    if (sort.length > 0) {
      params = { ...params,
        ...this.formatSort(sort)
      };
    }

    if (includes.length > 0) {
      params = { ...params,
        ...{
          include: includes.join(',')
        }
      };
    }

    const {
      data
    } = await this.http.get('/category-options', {
      params
    });
    return data;
  }
  /**
   * @param id
   * @returns ICategoryOption
   */


  async getCategoryOptionById(id) {
    const {
      data
    } = await this.http.get(`/category-options/${id}`);
    return data;
  }
  /**
   * @param slug
   * @returns ICategoryOption[]
   */


  async getCategoryOptionBySlug(slug) {
    const filters = [{
      operator: FilterOperator$1.Equals,
      property: 'value',
      value: slug
    }];
    const {
      data
    } = await this.http.get('/category-options', {
      params: { ...this.formatFilter(filters),
        include: RelationshipIncludes$1.All
      }
    });
    return data;
  }

}

class ProductGroupWrapper extends BaseWrapper {
  /**
   * @returns IProductGroup[]
   */
  async getProductGroups(pagination = {
    page: 1
  }, filters = [], sort = [], includes = []) {
    let params = { ...pagination
    };

    if (filters.length > 0) {
      params = { ...params,
        ...this.formatFilter(filters)
      };
    }

    if (sort.length > 0) {
      params = { ...params,
        ...this.formatSort(sort)
      };
    }

    if (includes.length > 0) {
      params = { ...params,
        ...{
          include: includes.join(',')
        }
      };
    }

    const {
      data
    } = await this.http.get('/product-groups', {
      params
    });
    return data;
  }
  /**
   * @param id
   * @returns IProductGroup
   */


  async getProductGroupById(id) {
    const {
      data
    } = await this.http.get(`/product-groups/${id}`);
    return data;
  }
  /**
   * @param slug
   * @returns IProductGroup[]
   */


  async getProductGroupBySlug(slug) {
    const filters = [{
      operator: FilterOperator$1.Equals,
      property: 'slug',
      value: slug
    }];
    const {
      data
    } = await this.http.get('/product-groups', {
      params: { ...this.formatFilter(filters),
        include: RelationshipIncludes$1.All
      }
    });
    return data;
  }

}

class SiteWrapper extends BaseWrapper {
  /**
   * @returns ISite[]
   */
  async getSites(pagination = {
    page: 1
  }, filters = [], sort = [], includes = []) {
    let params = { ...pagination
    };

    if (filters.length > 0) {
      params = { ...params,
        ...this.formatFilter(filters)
      };
    }

    if (sort.length > 0) {
      params = { ...params,
        ...this.formatSort(sort)
      };
    }

    if (includes.length > 0) {
      params = { ...params,
        ...{
          include: includes.join(',')
        }
      };
    }

    const {
      data
    } = await this.http.get('/sites', {
      params
    });
    return data;
  }
  /**
   * @param id
   * @returns ISite
   */


  async getSiteById(id) {
    const {
      data
    } = await this.http.get(`/sites/${id}`);
    return data;
  }
  /**
   * @param slug
   * @returns ISite[]
   */


  async getSiteBySlug(slug) {
    const filters = [{
      operator: FilterOperator$1.Equals,
      property: 'slug',
      value: slug
    }];
    const {
      data
    } = await this.http.get('/sites', {
      params: { ...this.formatFilter(filters),
        include: RelationshipIncludes$1.All
      }
    });
    return data;
  }

}

class TagWrapper extends BaseWrapper {
  /**
   * @returns ITag[]
   */
  async getTags(pagination = {
    page: 1
  }, filters = [], sort = [], includes = []) {
    let params = { ...pagination
    };

    if (filters.length > 0) {
      params = { ...params,
        ...this.formatFilter(filters)
      };
    }

    if (sort.length > 0) {
      params = { ...params,
        ...this.formatSort(sort)
      };
    }

    if (includes.length > 0) {
      params = { ...params,
        ...{
          include: includes.join(',')
        }
      };
    }

    const {
      data
    } = await this.http.get('/tags', {
      params
    });
    return data;
  }
  /**
   * @param id
   * @returns ISite
   */


  async getTagById(id) {
    const {
      data
    } = await this.http.get(`/tags/${id}`);
    return data;
  }
  /**
   * @param slug
   * @returns ISite[]
   */


  async getTagBySlug(slug) {
    const filters = [{
      operator: FilterOperator$1.Equals,
      property: 'slug',
      value: slug
    }];
    const {
      data
    } = await this.http.get('/tags', {
      params: { ...this.formatFilter(filters),
        include: RelationshipIncludes$1.All
      }
    });
    return data;
  }

}

/**
 * Creates a HTTP client factory
 *
 * @param baseURL - Base URL that will prefix all calls
 * @param apiKey - API key that will be attached to authorise the request
 * @param apiTokenStorageKey - API token that will be attached to authorise the request
 * @param refreshTokenStorageKey - API refresh token used for subsequent requests
 * @param storage - API token that will be attached to authorise the request
 */

var tokenHttpClient = ((baseURL, apiKey, apiTokenStorageKey, refreshTokenStorageKey, storage) => {
  const client = apiKeyHttpClient(baseURL, apiKey);
  const auth = new AuthWrapper(client);
  client.interceptors.request.use(config => {
    const apiToken = storage.getItem(apiTokenStorageKey);

    if (config.headers) {
      config.headers.Authorization = 'Bearer ' + apiToken;
    }

    return config;
  }, error => {
    Promise.reject(error);
  }); // @ts-ignore

  const refreshAuthLogic = failedRequest => auth // @ts-ignore
  .refreshToken(storage.getItem(refreshTokenStorageKey)).then(response => {
    const responseApiToken = response.token.api_token;
    storage.setItem(apiTokenStorageKey, responseApiToken);
    storage.setItem(refreshTokenStorageKey, response.token.refresh_token);
    failedRequest.response.config.headers.Authorization = 'Bearer ' + responseApiToken;
    return Promise.resolve();
  }).catch(error => {
    console.error('%o', error);
    storage.removeItem(apiTokenStorageKey);
    storage.removeItem(refreshTokenStorageKey);
  }); // Instantiate the interceptor


  createAuthRefreshInterceptor__default["default"](client, refreshAuthLogic);
  return client;
});

class SessionStorage {
  getItem(key) {
    // @ts-ignore
    if (typeof window !== 'undefined') {
      // @ts-ignore
      return sessionStorage.getItem(key);
    }

    return null;
  }

  setItem(key, value) {
    // @ts-ignore
    if (typeof window !== 'undefined') {
      // @ts-ignore
      sessionStorage.setItem(key, value);
    }
  }

  removeItem(key) {
    // @ts-ignore
    if (typeof window !== 'undefined') {
      // @ts-ignore
      sessionStorage.removeItem(key);
    }
  }

}

class UserWrapper extends BaseWrapper {
  /**
   *
   * @param id
   * @returns IUser
   */
  async getUserById(id) {
    const {
      data
    } = await this.http.get('/users/' + id);
    return data;
  }
  /**
   *
   * @param user - Create user DTO
   * @returns IUser
   */


  async createUser(user) {
    const {
      data
    } = await this.http.post('/users', user);
    return data;
  }
  /**
   *
   * @param id
   * @param user
   * @returns IUser
   */


  async updateUser(id, user) {
    const {
      data
    } = await this.http.put('/users/' + id, user);
    return data;
  }
  /**
   public function getFavourites($userId)
    public function addProductToFavourites($userId, $productId)
    public function removeProductFromFavourites($userId, $productId)
    public function getUserProductRecommendations($userId)
   **/


}

class CustomerWrapper extends BaseWrapper {
  /**
   *
   * @param id
   * @returns ICustomer
   */
  async getCustomerById(id) {
    const {
      data
    } = await this.http.get('/customers/' + id);
    return data;
  }
  /**
   *
   * @param customer - Create customer DTO
   * @returns ICustomer
   */


  async createCustomer(customer) {
    const {
      data
    } = await this.http.post('/customers', customer);
    return data;
  }
  /**
   *
   * @param id
   * @param customer
   * @returns ICustomer
   */


  async updateCustomer(id, customer) {
    const {
      data
    } = await this.http.put('/customers/' + id, customer);
    return data;
  }
  /**
   *
   * @param id
   * @param pagination
   * @param filters
   * @param sort
   * @param includes
   */


  async getCustomerOrders(id, pagination = {
    page: 1
  }, filters = [], sort = [], includes = []) {
    let params = { ...pagination
    };

    if (filters.length > 0) {
      params = { ...params,
        ...this.formatFilter(filters)
      };
    }

    if (sort.length > 0) {
      params = { ...params,
        ...this.formatSort(sort)
      };
    }

    if (includes.length > 0) {
      params = { ...params,
        ...{
          include: includes.join(',')
        }
      };
    }

    const {
      data
    } = await this.http.get('/customers/' + id + '/orders', {
      params
    });
    return data;
  }
  /**
   *
   * @param id
   * @param orderId
   * @returns IOrder
   */


  async getCustomerOrder(id, orderId) {
    const {
      data
    } = await this.http.get('/customers/' + id + '/orders/' + orderId);
    return data;
  }

}

class ApiWrapper {
  /** AccountWrapper */

  /** AuthWrapper */

  /** AnalyticWrapper */

  /** StoreWrapper */

  /** PageWrapper */

  /** ProductWrapper */

  /** BasketWrapper */

  /** ProductTypeWrapper */

  /** CategoryWrapper */

  /** CategoryOptionWrapper */

  /** ProductGroupWrapper */

  /** UserWrapper */

  /** SiteWrapper */

  /** TagWrapper */

  /** CustomerWrapper */
  constructor(tokenAuthentication = true, tokenStorage = new SessionStorage()) {
    Config.validate();
    const apiKeyClient = apiKeyHttpClient(Config.baseUrl, Config.key);
    const tokenClient = tokenAuthentication ? tokenHttpClient(Config.baseUrl, Config.key, Config.apiTokenStorageKey, Config.refreshTokenStorageKey, tokenStorage) : apiKeyClient;
    this.accountWrapper = new AccountWrapper(tokenClient);
    this.authWrapper = new AuthWrapper(apiKeyClient);
    this.analyticWrapper = new AnalyticWrapper(tokenClient);
    this.storeWrapper = new StoreWrapper(tokenClient);
    this.productWrapper = new ProductWrapper(tokenClient);
    this.pageWrapper = new PageWrapper(tokenClient);
    this.siteWrapper = new SiteWrapper(tokenClient);
    this.basketWrapper = new BasketWrapper(tokenClient);
    this.productTypeWrapper = new ProductTypeWrapper(tokenClient);
    this.categoryWrapper = new CategoryWrapper(tokenClient);
    this.categoryOptionWrapper = new CategoryOptionWrapper(tokenClient);
    this.productGroupWrapper = new ProductGroupWrapper(tokenClient);
    this.userWrapper = new UserWrapper(tokenClient);
    this.tagWrapper = new TagWrapper(tokenClient);
    this.customerWrapper = new CustomerWrapper(tokenClient);
  }
  /**
   *
   * @param email
   * @param password
   * @returns IUser
   */


  async login(email, password) {
    return this.accountWrapper.login(email, password);
  }
  /**
   *
   * @param code
   * @returns IResponse
   */


  async activateAccount(code) {
    return this.accountWrapper.activateAccount(code);
  }
  /**
   *
   * @param email
   * @returns IResponse
   */


  async resendActivation(email) {
    return this.accountWrapper.resendActivation(email);
  }
  /**
   *
   * @param email
   * @returns IResponse
   */


  async forgottenPassword(email) {
    return this.accountWrapper.forgottenPassword(email);
  }
  /**
   *
   * @param code
   * @param password
   * @returns IResponse
   */


  async resetPassword(code, password) {
    return this.accountWrapper.resetPassword(code, password);
  }
  /**
   * @returns IToken
   */


  async generateToken() {
    return this.authWrapper.generateToken();
  }
  /**
   * @param apiToken
   * @returns IToken
   */


  async getTokenByToken(apiToken) {
    return this.authWrapper.getTokenByToken(apiToken);
  }
  /**
   * @param apiToken
   * @returns IToken
   */


  async refreshToken(apiToken) {
    return this.authWrapper.refreshToken(apiToken);
  }
  /**
   *
   * @param analyticData
   * @returns IAnalytic
   */


  async trackAnalytic(analyticData) {
    return this.analyticWrapper.trackAnalytic(analyticData);
  }
  /**
   * @param productId
   * @param analyticData
   * @returns IAnalytic
   */


  async trackAnalyticByProductId(productId, analyticData) {
    return this.analyticWrapper.trackAnalyticByProductId(productId, analyticData);
  }
  /**
   * @returns StoreWrapper
   */


  async getStore(includes = []) {
    return this.storeWrapper.getStore(includes);
  }
  /**
   * @returns IProduct[]
   */


  async getProducts(pagination = {
    page: 1
  }, filters = [], sort = [], includes = []) {
    return this.productWrapper.getProducts(pagination, filters, sort, includes);
  }
  /**
   * @param id
   * @returns IProduct
   */


  async getProductById(id) {
    return this.productWrapper.getProductById(id);
  }
  /**
   * @param slug
   * @returns IProduct[]
   */


  async getProductBySlug(slug) {
    return this.productWrapper.getProductBySlug(slug);
  }
  /**
   * @returns IProduct[]
   */


  async getRecommendedProducts(productIds, pagination = {
    page: 1
  }, filters = [], sort = [] //includes: Array<string> = [],
  ) {
    return this.productWrapper.getRecommendedProducts(productIds, pagination, filters, sort);
  }
  /**
   * @returns IProduct[]
   */


  async searchProducts(query, pagination = {
    page: 1
  }, filters = [], sort = [], includes = []) {
    return this.productWrapper.searchProducts(query, pagination, filters, sort, includes);
  }
  /**
   * @returns IPage[]
   */


  async getPages() {
    return this.pageWrapper.getPages();
  }
  /**
   *
   * @param id
   * @returns IPage
   */


  async getPageById(id) {
    return this.pageWrapper.getPageById(id);
  }
  /**
   *
   * @param slug
   * @returns IPage[]
   */


  async getPageBySlug(slug) {
    return this.pageWrapper.getPageBySlug(slug);
  }
  /**
   * @returns ISite[]
   */


  async getSites() {
    return this.siteWrapper.getSites();
  }
  /**
   *
   * @param id
   * @returns ISite
   */


  async getSiteById(id) {
    return this.siteWrapper.getSiteById(id);
  }
  /**
   *
   * @param slug
   * @returns ISite[]
   */


  async getSiteBySlug(slug) {
    return this.siteWrapper.getSiteBySlug(slug);
  }
  /**
   * @param basketReference
   * @returns IBasket
   */


  async getBasketById(basketReference) {
    return this.basketWrapper.getBasketById(basketReference);
  }
  /**
   * @param basketData
   * @param deliveryTypeId
   * @returns IBasket
   */


  async createBasket(basketData, deliveryTypeId = 0) {
    return this.basketWrapper.createBasket(basketData, deliveryTypeId);
  }
  /**
   * @param basketReference
   * @param basketData
   * @param deliveryTypeId
   * @returns IBasket
   */


  async updateBasket(basketReference, basketData, deliveryTypeId = 0) {
    return this.basketWrapper.updateBasket(basketReference, basketData, deliveryTypeId);
  }
  /**
   * @param basketReference
   * @param productId
   * @param quantity
   * @returns IBasket
   */


  async addProductToBasket(basketReference, productId, quantity = 1) {
    return this.basketWrapper.addProductToBasket(basketReference, productId, quantity);
  }
  /**
   * @param basketReference
   * @param productId
   * @returns IBasket
   */


  async deleteProductFromBasket(basketReference, productId) {
    return this.basketWrapper.deleteProductFromBasket(basketReference, productId);
  }
  /**
   * @returns IProductType[]
   */


  async getProductTypes(pagination = {
    page: 1
  }, filters = [], sort = [], includes = []) {
    return this.productTypeWrapper.getProductTypes(pagination, filters, sort, includes);
  }
  /**
   * @param id
   * @returns IProductType
   */


  async getProductTypeById(id) {
    return this.productTypeWrapper.getProductTypeById(id);
  }
  /**
   * @param slug
   * @returns IProductType[]
   */


  async getProductTypeBySlug(slug) {
    return this.productTypeWrapper.getProductTypeBySlug(slug);
  }
  /**
   * @returns ICategory[]
   */


  async getCategories(pagination = {
    page: 1
  }, filters = [], sort = [], includes = []) {
    return this.categoryWrapper.getCategories(pagination, filters, sort, includes);
  }
  /**
   * @param id
   * @returns ICategory
   */


  async getCategoryById(id) {
    return this.categoryWrapper.getCategoryById(id);
  }
  /**
   * @param slug
   * @returns ICategory[]
   */


  async getCategoryBySlug(slug) {
    return this.categoryWrapper.getCategoryBySlug(slug);
  }
  /**
   * @returns ICategoryOptions[]
   */


  async getCategoryOptions(pagination = {
    page: 1
  }, filters = [], sort = [], includes = []) {
    return this.categoryOptionWrapper.getCategoryOptions(pagination, filters, sort, includes);
  }
  /**
   * @param id
   * @returns ICategoryOption
   */


  async getCategoryOptionById(id) {
    return this.categoryOptionWrapper.getCategoryOptionById(id);
  }
  /**
   * @param slug
   * @returns ICategoryOption[]
   */


  async getCategoryOptionBySlug(slug) {
    return this.categoryOptionWrapper.getCategoryOptionBySlug(slug);
  }
  /**
   * @returns IProductGroup[]
   */


  async getProductGroups(pagination = {
    page: 1
  }, filters = [], sort = [], includes = []) {
    return this.productGroupWrapper.getProductGroups(pagination, filters, sort, includes);
  }
  /**
   * @param id
   * @returns IProductGroup
   */


  async getProductGroupById(id) {
    return this.productGroupWrapper.getProductGroupById(id);
  }
  /**
   * @param slug
   * @returns IProductGroup[]
   */


  async getProductGroupBySlug(slug) {
    return this.productGroupWrapper.getProductGroupBySlug(slug);
  }
  /**
   *
   * @param id
   * @returns IUser
   */


  async getUserById(id) {
    return this.userWrapper.getUserById(id);
  }
  /**
   *
   * @param user - Create user DTO
   * @returns IUser
   */


  async createUser(user) {
    return this.userWrapper.createUser(user);
  }
  /**
   *
   * @param id
   * @param user
   * @returns IUser
   */


  async updateUser(id, user) {
    return this.userWrapper.updateUser(id, user);
  }
  /**
   * @returns ITag[]
   */


  async getTags() {
    return this.tagWrapper.getTags();
  }
  /**
   *
   * @param id
   * @returns ITag
   */


  async getTagById(id) {
    return this.tagWrapper.getTagById(id);
  }
  /**
   *
   * @param slug
   * @returns ITag[]
   */


  async getTagBySlug(slug) {
    return this.tagWrapper.getTagBySlug(slug);
  }
  /**
   * @param id
   * @returns ICustomer
   */


  async getCustomerById(id) {
    return this.customerWrapper.getCustomerById(id);
  }
  /**
   *
   * @param customer - Create customer DTO
   * @returns ICustomer
   */


  async createCustomer(customer) {
    return this.customerWrapper.createCustomer(customer);
  }
  /**
   *
   * @param id
   * @param customer
   * @returns ICustomer
   */


  async updateCustomer(id, customer) {
    return this.customerWrapper.updateCustomer(id, customer);
  }
  /**
   *
   * @param id
   * @param pagination
   * @param filters
   * @param sort
   * @param includes
   * @return IOrder[]
   */


  async getCustomerOrders(id, pagination = {
    page: 1
  }, filters = [], sort = [], includes = []) {
    return this.customerWrapper.getCustomerOrders(id, pagination, filters, sort, includes);
  }
  /**
   *
   * @param id
   * @param orderId
   * @returns IOrder
   */


  async getCustomerOrder(id, orderId) {
    return this.customerWrapper.getCustomerOrder(id, orderId);
  }

}

class CookieStorage {
  getItem(key) {
    return Cookies__default["default"].get(key);
  }

  setItem(key, value) {
    Cookies__default["default"].set(key, value);
  }

  removeItem(key) {
    Cookies__default["default"].remove(key);
  }

}

exports.AccountWrapper = AccountWrapper;
exports.AnalyticWrapper = AnalyticWrapper;
exports.ApiWrapper = ApiWrapper;
exports.AuthWrapper = AuthWrapper;
exports.BasketWrapper = BasketWrapper;
exports.CategoryOptionWrapper = CategoryOptionWrapper;
exports.CategoryWrapper = CategoryWrapper;
exports.Config = Config;
exports.CookieStorage = CookieStorage;
exports.CustomerWrapper = CustomerWrapper;
exports.PageWrapper = PageWrapper;
exports.ProductGroupWrapper = ProductGroupWrapper;
exports.ProductTypeWrapper = ProductTypeWrapper;
exports.ProductWrapper = ProductWrapper;
exports.SessionStorage = SessionStorage;
exports.SiteWrapper = SiteWrapper;
exports.StoreWrapper = StoreWrapper;
exports.TagWrapper = TagWrapper;
exports.UserWrapper = UserWrapper;
//# sourceMappingURL=index.cjs.js.map
